import React from "react";
import styled from "styled-components/macro";

const ButtonContainer = styled.button`
  position: relative;
  /* Adapt the colours based on primary prop */
  background: ${(props) =>
    props.active ? props.theme.onSurfaceLight : "rgba(0,0,0,.05)"};
  color: ${(props) =>
    props.active ? props.theme.onSurfaceLightSecondary : "inherit"};
  cursor: pointer;
  font-size: ${(props) => (props.size === "small" ? ".8rem" : "1rem")};
  width: ${(props) => (props.span ? "100%" : "auto")};
  margin-right: ${(props) => (props.list ? "1rem" : "0")};
  padding: 0.5em 1em;
  display: ${(props) => (props.display ? props.display : "")};
  border: none;
  transition: all ${(props) => props.theme.transitionSpeed} linear;
  &:hover {
    background: ${(props) =>
      props.primary
        ? props.theme.surfaceAlt
        : props.danger
        ? props.theme.dangerAlt
        : props.theme.surfaceAlt};
  }
  &:focus {
    border: none;
  }
  &:disabled {
    opacity: 0.3;
    cursor: auto;
    background: ${(props) =>
      props.primary
        ? props.theme.onSurfaceLight
        : props.danger
        ? props.theme.danger
        : props.theme.onSurfaceLight};
  }
`;

const ButtonCenter = styled.div`
  width: 100%;
  text-align: center;
`;

const ButtonInner = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonIcon = styled.div`
  margin-right: ${(props) => (props.iconBump ? ".5rem" : "")};
`;

const ToggleComponent = (props) => {
  const IconComponent = props?.icon ?? null;

  return props.center ? (
    <ButtonCenter>
      <ButtonContainer {...props}>
        <ButtonInner>
          {IconComponent && (
            <ButtonIcon iconBump={props.iconBump}>
              <IconComponent />
            </ButtonIcon>
          )}
          {props.children}
        </ButtonInner>
      </ButtonContainer>
    </ButtonCenter>
  ) : (
    <ButtonContainer {...props}>
      <ButtonInner>
        {IconComponent && (
          <ButtonIcon iconBump={props.iconBump}>
            <IconComponent />
          </ButtonIcon>
        )}
        {props.children}
      </ButtonInner>
    </ButtonContainer>
  );
};

export default ToggleComponent;
